<template>
    <div style="height: 100%;background: #ffffff;" class="flx">
        <el-row class="flxs">
            <el-button size="small" icon="el-icon-back" @click="reback">返回</el-button>
        </el-row>
        <el-form :model="form" ref="form" :rules="rules" label-width="120px" class="mt30 mb15">

            <el-form-item label="文章标题:" prop="title">
                <el-input v-model="form.title" class="w600" placeholder="请输入服务名称" />
            </el-form-item>

            <el-form-item label="内容:">
                <vue-ueditor-wrap v-model="form.content" :config="myConfig" />
            </el-form-item>

            <el-row>
                <el-form-item>
                    <el-button type="primary" @click="submitDetail('form')">提交</el-button>
                </el-form-item>
            </el-row>

        </el-form>
    </div>
</template>
<script>
import { renew, details } from '@/Api/Introduce/index.js'
import VueUeditorWrap from 'vue-ueditor-wrap'
import config from '@/utils/ueditorConfig'
export default {
    name: 'SystemIntroduceEdit',
    components: {
        VueUeditorWrap,
    },
    data() {
        return {
            id: null,
            myConfig: config,
            tableData: [],
            form: {
                title: 465,
                content: '123'
            },
            rules: {
                title: [
                    { required: true, message: '请填写文章标题', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        reback() {
            this.$router.push('/introduce')
        },
        getDetail() {
            details({ ids: this.id, }).then(res => {
                if (res.code == 1) {
                    var detail = res.data
                    this.form = {
                        title: detail.title,
                        content: detail.content,
                    };
                }
            })
        },
        submitDetail(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.form.content) {
                        this.$message_e('请填写内容')
                        return
                    }
                    console.log(this.form);
                    this.form.ids = this.id
                    renew(this.form).then(res => {
                        if (res.code == 1) {
                            this.$message_c(res.msg)
                            this.$router.push('/introduce')
                        } else {
                            this.$message_e(res.msg)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
    watch: {
        '$route.query.id': {
            immediate: true,
            handler(newId) {
                if (newId) {
                    this.id = newId
                    this.getDetail()
                }
            }
        }
    },

}
</script>
<style lang="scss" scoped>
::v-deep .el-input {
    width: 400px;
}

::v-deep .el-textarea__inner {
    width: 400px;
}

::v-deep .el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: #ffffff;
}

.flx {
    height: calc(100vh - 60px) !important;
    padding: 20px 10px 30px 10px;
    overflow: scroll;
}

.zhanwei {
    margin: 15px 0;
}

.css {
    margin-left: 10px;
}

.border {
    height: 2px;
    background: #eeeeee;
    margin-bottom: 10px;
}

::v-deep .el-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.btn {
    margin-left: 50px;
    color: #ffffff;
}

.el-table {
    margin-top: 30px;
}

.ipt {
    width: 200px;
}

.fenye {
    text-align: right;
    margin-top: 30px;
}

.btnpermess {
    margin-right: 90px;
}

.flxs {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>